import { render, staticRenderFns } from "./CloseContactRequestDialog.vue?vue&type=template&id=42e8a04d"
import script from "./CloseContactRequestDialog.vue?vue&type=script&lang=ts"
export * from "./CloseContactRequestDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports